export function getFileNameFromContentDisposition(
  contentDisposition?: string | null
): string | null {
  if (!contentDisposition) return null;

  // RFC 5987: filename*=UTF-8''...
  const star = contentDisposition.match(/filename\*\s*=\s*([^;]+)/i);
  if (star?.[1]) {
    const raw = star[1].trim().replace(/^"(.*)"$/, '$1');
    const value = raw.replace(/^UTF-8''/i, '');
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }

  // filename="..."
  const normal = contentDisposition.match(/filename\s*=\s*("?)([^";]+)\1/i);
  return normal?.[2] ?? null;
}





